import { initPlasmicLoader } from "@plasmicapp/loader-react";
export const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: "vBcMyVvohcRf6jTAAhLpUM",  // ID of a project you are using
      token: "vqIdGfd8oUzOJr3z6hAZo1L4oP0kQpMeNCJMZdA5FdyhTGc57Ni5TdORUccurPcoIC3P7Ax7M7TpS5RJJEGA"  // API token for that project
    }
  ],
  // Fetches the latest revisions, whether or not they were unpublished!
  // Disable for production to ensure you render only published changes.
  preview: true,
})